import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import { useClient } from "../../client/Client"
import ClientDetailView from './ClientDetailView'

const ClientEdit = () => {
    const navigate = useNavigate()

    let { id } = useParams()
    let {
        companyName, setCompanyName,
        sector, setSector,
        salesPerson, setSalesPerson,
        status, setStatus,
        statusUpdated, setStatusUpdated,
        initialPrice, setInitialPrice,
        monthlyPrice, setMonthlyPrice,
        initialPaymentDate, setInitialPaymentDate,
        serviceAgreementStart, setServiceAgreementStart,
        serviceAgreementEnd, setServiceAgreementEnd,
        builtWebsite, setBuiltWebsite,
        tags, setTags,
        contactPersonName, setContactPersonName,
        emailAddress, setEmailAddress,
        phoneNumber, setPhoneNumber,
        notes, setNotes,
        tasks, setTasks,
    } = useClient(id)

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client !== undefined && !permissions.client) {
            toast.error("You don't have permission to edit clients!")
            navigate("/")
        }
    }, [permissions])

    return <ClientDetailView id={id}
        companyName={companyName} setCompanyName={setCompanyName}
        sector={sector} setSector={setSector}
        salesPerson={salesPerson} setSalesPerson={setSalesPerson}
        status={status} setStatus={setStatus}
        statusUpdated={statusUpdated} setStatusUpdated={setStatusUpdated}
        initialPrice={initialPrice} setInitialPrice={setInitialPrice}
        monthlyPrice={monthlyPrice} setMonthlyPrice={setMonthlyPrice}
        initialPaymentDate={initialPaymentDate} setInitialPaymentDate={setInitialPaymentDate}
        serviceAgreementStart={serviceAgreementStart} setServiceAgreementStart={setServiceAgreementStart}
        serviceAgreementEnd={serviceAgreementEnd} setServiceAgreementEnd={setServiceAgreementEnd}
        builtWebsite={builtWebsite} setBuiltWebsite={setBuiltWebsite}
        tags={tags} setTags={setTags}
        contactPersonName={contactPersonName} setContactPersonName={setContactPersonName}
        emailAddress={emailAddress} setEmailAddress={setEmailAddress}
        phoneNumber={phoneNumber} setPhoneNumber={setPhoneNumber}
        notes={notes} setNotes={setNotes}
        tasks={tasks} setTasks={setTasks}
    />
}

export default ClientEdit